import { Popover, Transition } from '@headlessui/react';
import { ChevronDownIcon, UserCircleIcon } from '@heroicons/react/20/solid';
import { ControlContext } from 'provider/ControlProvider';
import { Fragment, useContext } from 'react';
import { useQuery, useMutation, useApolloClient } from '@apollo/client';
import { GetCustomerInfo } from 'graphql/query';
import { SIGNOUT_USER } from 'graphql/auth';
import CommonButton from 'components/CommonButton';

export default function UserPanel() {
  const { setToken } = useContext(ControlContext);
  const apolloClient = useApolloClient();
  const data = useQuery(GetCustomerInfo, {
    variables: { customerAccessToken: localStorage.getItem('accessToken') },
  });

  const [signoutCustomer, { client }] = useMutation(SIGNOUT_USER, {
    onCompleted: () => {
      // Clear all cached data when user signs out
      client.cache.reset().then(() => {
        // Reload the page to reset the UI
        window.location.reload();
      });
    },
  });
  const signOut = async () => {
    await signoutCustomer({
      variables: {
        customerAccessToken: localStorage.getItem('accessToken'),
      },
    });
    apolloClient.resetStore();
    localStorage.clear();
    setToken('');
  };
  return (
    <Popover className='relative hidden md:block'>
      {({ open }) => (
        <>
          <Popover.Button
            className={`
                ${open ? '' : 'text-opacity-90'}
                group inline-flex items-center rounded-md bg-transparent md:bg-thirdColor px-3 py-2 text-base font-medium text-white hover:text-opacity-100 focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75`}
          >
            <div className='flex justify-start space-x-4 md:space-x-0 items-center text-white'>
              <UserCircleIcon className='w-8 md:w-5' />
              <p className='text-base md:text-sm font-medium'>Account</p>
            </div>
            <ChevronDownIcon
              className={`${open ? '' : 'text-opacity-70'}
                  ml-2 h-5 w-5 text-orange-300 transition duration-150 ease-in-out group-hover:text-opacity-80`}
              aria-hidden='true'
            />
          </Popover.Button>
          <Transition
            as={Fragment}
            enter='transition ease-out duration-200'
            enterFrom='opacity-0 translate-y-1'
            enterTo='opacity-100 translate-y-0'
            leave='transition ease-in duration-150'
            leaveFrom='opacity-100 translate-y-0'
            leaveTo='opacity-0 translate-y-1'
          >
            <Popover.Panel className='md:absolute md:right-0 z-10 mt-3 w-full md:w-60  '>
              <div className='overflow-hidden rounded-b-lg shadow-lg ring-1 ring-black ring-opacity-5'>
                <div className='bg-transparent md:bg-forthColor p-4'>
                  <div className='flow-root rounded-md px-2 py-2 transition duration-150 ease-in-out focus:outline-none focus-visible:ring focus-visible:ring-orange-500 focus-visible:ring-opacity-50'>
                    <div className='flex items-center justify-start space-x-2 text-sm font-medium text-white'>
                      <span>
                        {data.data?.customer?.firstName ?? 'loading...'}
                      </span>
                      <span>{data.data?.customer?.lastName ?? ''}</span>
                    </div>
                    <span className='block text-sm text-gray-200 mt-3'>
                      {data.data?.customer?.email ?? 'loading...'}
                    </span>
                    <span className='block text-sm text-gray-200'>
                      {data.data?.customer?.phone ?? 'loading...'}
                    </span>
                  </div>
                  <CommonButton
                    className='w-full h-10 rounded-md mt-2'
                    onClick={(e) => {
                      e.preventDefault();
                      signOut();
                    }}
                  >
                    Sign Out
                  </CommonButton>
                </div>
              </div>
            </Popover.Panel>
          </Transition>
        </>
      )}
    </Popover>
  );
}
